import { getParticipant } from '@/core/data/coachings'
import { downloadFile } from '@/core/data/storage'
import { downloadBlob, extForMime, personDownloadName } from '@/core/lib/files'

export async function downloadStaffDocument(
  path: string | null | undefined,
  coachingId: string | null,
  prefix: 'AVGS' | 'Bewilligung' | 'TB',
): Promise<void> {
  if (!path) return
  const blob = await downloadFile(path)
  const ext = prefix === 'TB' ? 'pdf' : extForMime(blob?.type)
  const fallback = prefix === 'TB' ? "Traegerbestaetigung" : prefix
  let filename = `${fallback}_${coachingId}.${ext}`
  try {
    const participant = coachingId ? await getParticipant(coachingId) : null
    filename = personDownloadName(prefix, participant?.nachname, participant?.vorname, filename, ext)
  } catch (e) {
    console.error(`${prefix}-Name für Download fehlgeschlagen:`, e)
  }
  downloadBlob(blob, filename)
}
